import { useGetTicketsCompleteCustomerLookupCountQuery } from 'services/tickets';
import { FindAllTicketsCompleteCustomerLookupDto } from 'types/dto/ticket';

export function useTicketsCompleteCustomerLookupCount(
  params: Omit<FindAllTicketsCompleteCustomerLookupDto, 'pageIndex' | 'pageSize'>
) {
  const {
    customerName,
    customerAddress,
    meterSerialNumber,
    customerCode,
    routeCode,
    meterPointCode,
    organizationUnitCode,
    wardId,
    districtId,
    ticketId,
    customerPhoneNumber,
    administrativeUnitId,
    contactId
  } = params;

  const shouldFetch = !!(
    customerName ||
    customerAddress ||
    meterSerialNumber ||
    customerCode ||
    routeCode ||
    meterPointCode ||
    organizationUnitCode ||
    wardId ||
    districtId ||
    ticketId ||
    customerPhoneNumber ||
    administrativeUnitId ||
    contactId
  );

  const queryParams = shouldFetch
    ? {
        customerName,
        customerAddress,
        meterSerialNumber,
        customerCode,
        routeCode,
        meterPointCode,
        organizationUnitCode,
        wardId,
        districtId,
        ticketId,
        customerPhoneNumber,
        administrativeUnitId,
        contactId
      }
    : {
        customerName: '',
        customerAddress: '',
        meterSerialNumber: '',
        customerCode: '',
        routeCode: '',
        meterPointCode: '',
        organizationUnitCode: '',
        wardId: undefined,
        districtId: undefined,
        ticketId: '',
        customerPhoneNumber: '',
        administrativeUnitId: 0,
        contactId: 0
      };

  const { data: count } = useGetTicketsCompleteCustomerLookupCountQuery(queryParams, {
    skip: !shouldFetch
  });

  return {
    count: shouldFetch ? count?.data || 0 : 0
  };
}
